import { render, staticRenderFns } from "./SriRiskIndicators.vue?vue&type=template&id=8253d83e&scoped=true"
import script from "./SriRiskIndicators.vue?vue&type=script&lang=js"
export * from "./SriRiskIndicators.vue?vue&type=script&lang=js"
import style0 from "./SriRiskIndicators.vue?vue&type=style&index=0&id=8253d83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8253d83e",
  null
  
)

export default component.exports